import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const MiddleNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const name = useAppSelector(state => state.registration.currentRegistration?.name) || {};
  const value = name.middle || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      name: {
        ...name,
        middle: e.target.value,
      },
    }));
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      size="small"
      label="Middle Name"
    />
  );
};

export default MiddleNameEdit;
